<template>
  <v-row
    dense
    align="center"
    justify="center"
  >
    <!-- num -->
    <v-col
      cols="1"
      class="text-caption primary--text text-right"
    >
      <span>{{ value }}%</span>
    </v-col>
    <!-- bar -->
    <v-col cols="8">
      <!-- show container -->
      <div
        id="progressBar"
        class="secondary"
      >
        <!-- loading container -->
        <div
          id="loadingContainer"
          class="d-flex"
        >
          <!-- Main bar -->
          <div
            id="mainBar"
            class="primary"
            :style="`width:${value/1.6}%`"
          ></div>
          <!-- Trailing fade -->
          <div id="fadedBar"></div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'MainProgressBar',

    props: {
      value: { type: Number, default: 0 }

    }
  }
</script>

<style lang="scss" scoped>
  // CSS for custom loading bar
  #progressBar {
    height:3px;
    width:100%;
    overflow:hidden;

    #loadingContainer {
      width:150%;
      height:100%;
    }
    #mainBar {
      transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
      height:100%;
    }
    #fadedBar {
      width:10%;
      background-image: linear-gradient(to right, #258bf5, rgba(1,1,1,0));
      height:100%;
    }
  }
</style>